export enum MenuBackColor {

    CLARO = "CLARO",
    OSCURO = "OSCURO"
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/seguridad/emisor/recursos/modelo/MenuBackColor.ts